import { queryOptions, useQuery } from "@tanstack/react-query";
import bankNameService from "../services/bank-name-service";

export const bankNamesQueryOptions = () =>
    queryOptions({
        queryKey: ["bank-names"],
        queryFn: () => bankNameService.list(),
        staleTime: 1000 * 60 * 60,
    });

export const useBankNames = () => useQuery(bankNamesQueryOptions());

export const useBankNameOptions = () => {
    const query = useBankNames();
    const options = (query.data ?? []).map((bank) => ({
        value: bank.bank_name,
        label: bank.bank_name,
    }));
    return { ...query, options };
};
